import styled from "styled-components";

/**
 * Local copy of `orchestrator/shared/components/criteria/styles.ts`'s `StyledDatePickerWrapper`,
 * kept module-local per PLAN-03-backoffice-ng.md §5.5's recommendation so `experiment/` stays
 * self-contained rather than reaching into a sibling module for a single wrapper.
 */
export const StyledDateFieldWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
    width: 100%;
  }

  .react-datepicker__input-container {
    display: block;
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
  }
`;
